import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SelectPicker/Panel.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    staticClass: "select-picker",
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('popup-header', {
    attrs: {
      "left-text": i18n.tc("11"),
      "right-text": i18n.tc("12"),
      "title": _vm.title,
      "show-bottom-border": false
    },
    on: {
      "on-click-left": _vm.leftClick,
      "on-click-right": _vm.rigthClick
    }
  }), _c(__unplugin_components_0, {
    ref: "Panel",
    attrs: {
      "list": _vm.displayJsonFilter,
      "selectedValue": _vm.selectedValue
    },
    on: {
      "on-change": _vm.change
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };